/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/

import vm from '../../main.js'

import pouch from '@/db/pouch';

export default {
  addFactory({
    commit
  }, factory) {
    return new Promise(async (resolve, reject) => {
      try {
        return await pouch.en(factory).then(async (et) => {
          return await pouch.f({
            selector: {
              c: et.c,
              z: 5
            }
          }, true, false).then(async (sr) => {
            if (sr.hasOwnProperty('a')) {
              return reject('A factory exists with this initial. Try again with a different initial.');
            } else {
              return await pouch.c(et, true).then((ct) => {
                if (ct.ok) {
                  return resolve('Factory successfully registered');
                }
                return reject(ct.message);
              })
            }
          })
        });
      } catch (e) {
        return reject(e);
      }
    })
  },
  updateFactory({
    commit
  }, factory) {
    return new Promise(async (resolve, reject) => {
      return await pouch.f({
        selector: {
          _id: factory._id,
          z: 5,
        }
      }, true, false).then(async (sr) => {
        if (sr.hasOwnProperty('a')) {
          return await pouch.c(factory, false).then((ct) => {
            if (ct.ok) {
              return resolve('Factory successfully updated');
            }
            return reject(ct.message);
          }).catch((e) => reject(e))
        } else {
          return reject('This factory has not been found. It might no longer exist in your database.');
        }
      });
    })
  },
}